import { Button, Modal, ModalFooter, ModalHeader } from "modules/common";
import React from "react";

interface Props {
  isVisible: boolean;
  toggleModal: () => void;
}

export const AccessibilityStatementModal: React.FC<Props> = ({
  isVisible,
  toggleModal,
}) => {
  return (
    <Modal
      isActive={isVisible}
      onClose={toggleModal}
      modalHeader={
        <ModalHeader
          onClose={toggleModal}
          title="Izjava o pristupačnosti"
          isLoading={false}
        />
      }
      modalFooter={
        <ModalFooter>
          <Button
            type="button"
            size="small"
            variant="warning"
            onClick={toggleModal}
          >
            <span>Zatvori</span>
          </Button>
        </ModalFooter>
      }
    >
      <div className="mt-40 mr-40 mb-40 ml-40">
        <p>
          Ministarstvo poljoprivrede, šumarstva i ribarstva nastoji svoje
          mrežne stranice učiniti pristupačnima u skladu sa Zakonom o
          pristupačnosti mrežnih stranica i programskih rješenja za pokretne
          uređaje tijela javnog sektora Republike Hrvatske („Narodne novine“,
          broj 17/19; dalje u tekstu: Zakon) kojim se prenosi Direktiva (EU)
          2016/2102 Europskog parlamenta i Vijeća od 26. listopada 2016. o
          pristupačnosti internetskih stranica i mobilnih aplikacija tijela
          javnog sektora (SL L 327, 2.12.2016.).
        </p>
        <p>
          Ova Izjava o pristupačnosti primjenjuje se na portal eSavjetnik u
          sklopu portala e-Poljoprivreda, a nalazi na adresi{" "}
          <a
            href="https://epoljoprivreda.mps.hr"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://epoljoprivreda.mps.hr
          </a>
          .
        </p>

        <h4>Stupanj usklađenosti</h4>
        <p>
          Portal https://epoljoprivreda.mps.hr/ djelomično je usklađen sa
          Zakonom zbog neusklađenosti navedenih u nastavku.
        </p>

        <h4>Nepristupačan sadržaj</h4>
        <ul>
          <li>dio postavljenih dokumenata nije dostupan u strojno čitljivom obliku</li>
          <li>ne postoji mogućnost uključivanja opcije za automatsko ispravljanje grešaka pri unosu teksta</li>
          <li>nedostaju oznake u dijelu Portala koji se odnosi na upis prijedloga ili komentara</li>
        </ul>
        <p>
          Ministarstvo poljoprivrede, šumarstva i ribarstva radi na uklanjanju
          uočenih neusklađenosti.
        </p>

        <h4>Priprema ove izjave o pristupačnosti</h4>
        <p>
          Ova izjava sastavljena je 5. svibnja 2025. godine, prema Predlošku
          izjave o pristupačnosti, koji je u skladu s Direktivom (EU) 2016/2102
          Europskog parlamenta i Vijeća te Provedbenom odlukom Komisije (EU)
          2018/1523. Procjena usklađenosti rezultat je samoprocjene Ministarstva
          poljoprivrede, šumarstva i ribarstva.
        </p>

        <h4>Povratne informacije i podaci za kontakt</h4>
        <p>
          Molimo korisnike ovih mrežnih stranica ako primijete neusklađen
          sadržaj, koji nije obuhvaćen ovom izjavom, da o tome obavijeste
          Ministarstvo poljoprivrede, šumarstva i ribarstva.
        </p>
        <p>
          Sve upite vezane uz pristupačnost portala ePoljoprivreda korisnici
          mogu uputiti putem e-pošte:{" "}
          <a href="mailto:pomoc@mps.hr">pomoc@mps.hr</a>
        </p>

        <h4>Postupak praćenja provedbe propisa</h4>
        <p>
          Povjerenik za informiranje Republike Hrvatske je tijelo nadležno za
          praćenje usklađenosti mrežnih stranica i programskih rješenja za
          pokretne uređaje tijela javnog sektora sa zahtjevima pristupačnosti
          kao i za nadzor nad provedbom Zakona.
        </p>
        <p>
          U slučaju nezadovoljavajućih odgovora na obavijest ili zahtjev za
          povratne informacije o pristupačnosti ovih mrežnih stranica, korisnici
          se mogu obratiti Povjereniku za informiranje putem e-pošte:{" "}
          <a href="mailto:pristupacnost@pristupinfo.hr">
            pristupacnost@pristupinfo.hr
          </a>
        </p>
      </div>
    </Modal>
  );
};
